import React from 'react'
import MainContainer from 'components/generic/MainContainer'
import styles from './psq.module.scss'

const Wrapper = ({ children }) => (
  <MainContainer className={styles.container}>{children}</MainContainer>
)

export default Wrapper
